import React from 'react';
import { Col, Row } from 'antd';
import { Button } from 'react-bootstrap';
import {SvgFilter} from "../common/SvgIcons";

const Filter = (props) => {
   return (<div>
      <div className="row" style={{ padding: "0px 10px 0px 10px" }} >
         <div className="col-12 exhibitor-search-header app-text-color gx-my-5 gx-px-2 gx-d-flex" style={{ justifyContent: 'space-between' }}>
            <div><h1 className='app-text-color'><b>Refined By</b></h1></div>
            <SvgFilter  className="exhibitor-icon-size" color={props.customThemeStyle.primary_color}/>
         </div>
      </div>
      <div>
         <h3 className='filter-header'><b>SUPPORT TYPE</b></h3>
         <div className="hierarchicalMenu gx-my-4">
            <ul className="filter-list-cover" >
               {props.supportType.length > 0 && props.supportType.map((tag, index) => (
                  <li key={"ListItem" + tag.value} key={`list-${index}`} id={"ListItem" + tag.value} className="filter-list">
                     <Row className='gx-mx-1'>
                        <Col span={17}>
                           <label className="ais-RefinementList-label app-text-color">
                              <input id={tag.value} className="filterCheckBox" checked={props.checkedBoxes.find((id) => id === tag.label) || ''} type="checkbox" value={tag.label} onChange={(e) => props.handleFilter(e)}></input>
                              <span className="filterLabel gx-pl-3">{tag.label}</span>
                           </label>
                        </Col>
                        <Col span={2}>
                           <span className="filterCount">{tag.count}</span>
                        </Col>
                     </Row>
                  </li>
               ))}

            </ul>
         </div>
         <button className='filter-button gx-mt-4' onClick={props.handleClearFilter}>Clear all filters</button>
      </div>
   </div>
   )
}

export default Filter